
























































































































































import Vue from "vue";
import { computed } from "@vue/composition-api";
import { SharedState } from "@/common/state";
export default Vue.extend({
  setup() {
    const is_light_theme = computed(() => SharedState.theme.value === "light");
    const items_color = computed(() =>
      is_light_theme.value ? "#293748" : "#787F87"
    );

    return {
      items_color
    };
  }
});
